export const CompanyHeader = () => (
  <header className='pb-12'>
    <div className='flex items-center mx-auto flex-col gap-y-3 text-center'>
      <div className='overflow-hidden w-[100px] h-[100px]'>
        <div className='animate-pulse bg-tertiary rounded-lg w-full h-full' />
      </div>
      <div className='flex flex-col gap-y-1'>
        <div className='w-full h-6 bg-tertiary rounded-sm animate-pulse text-headline-m text-transparent'>
          Xceed Test Venue commercial
        </div>
        <div className='w-full h-5 bg-tertiary rounded-sm animate-pulse text-body-m text-transparent'>
          Xceed Test Venue Company legal
        </div>
      </div>
    </div>
    <div className='flex justify-center items-center pt-8 pl-4 pb-0 overflow-x-auto scrollbar-hide w-full'>
      <nav className='inline-block whitespace-nowrap space-x-2 text-primary'>
        {['Info', 'Users', 'Integrations'].map((tab, index) => (
          <div
            key={tab}
            className={`inline-block whitespace-nowrap py-1.5 px-3 xs:py-2 xs:px-4 rounded-full ${
              index === 0 ? 'bg-tertiary-light' : 'bg-tertiary'
            } animate-pulse h-8 w-16`}
          />
        ))}
      </nav>
    </div>
  </header>
);
